"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecomposeAbilityHandler = exports.DecomposeActorAbilityFactory = exports.DecomposeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EffectType_1 = require("../../core/effects/EffectType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class DecomposeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Decompose;
        this.__typeName = "Decompose";
    }
}
exports.DecomposeAbilityArgs = DecomposeAbilityArgs;
let DecomposeActorAbilityFactory = class DecomposeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Decompose", "OneEnemies", 0);
    }
};
DecomposeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Decompose")
], DecomposeActorAbilityFactory);
exports.DecomposeActorAbilityFactory = DecomposeActorAbilityFactory;
let DecomposeAbilityHandler = class DecomposeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        const withers = container.getEffectsOfType(targetId, EffectType_1.EffectType.Withering)
            .map(eid => container.getEffect(eid));
        sequence = sequence.pushSequence("parallel");
        let i = 0;
        container.applyProjectileAttacksWithDamage({
            sequence: sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            projectiles: withers.map((w, i) => ({
                targetId,
                type: "RedSunOrb",
                path: i % 2 === 0 ? "sin"
                    : "cos",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", w.args.power)
                ]
            })),
            onHitOrMiss: (sequence, attack, damage) => {
                const wither = withers[i];
                container.cancelEffect(sequence, wither.id);
                i++;
            },
            onHit: (sequence, _attack, _damage, projectile) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(projectile.targetId, "chest"), "DarkMagicCircle"));
            }
        });
    }
};
DecomposeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Decompose)
], DecomposeAbilityHandler);
exports.DecomposeAbilityHandler = DecomposeAbilityHandler;
